var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"profilepreview"},[_c('header',[_c('a',{attrs:{"href":`/#/profiles/${_vm.profile.profileHandle}`}},[_vm._v(_vm._s(_vm.profile.profileHandle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }